import { useContext } from 'react';
import { UnleashContext } from './components/Context';
import { FeatureFlag } from './constants';
import { UnleashContextState } from './types';

export const useFeatureFlags = (): UnleashContextState => {
  const context = useContext(UnleashContext);

  if (context === undefined) {
    throw Error(
      'UnleashContext must be used inside UnleashContext Provider scope'
    );
  }

  return context;
};

export const useFeatureToggle = (
  TOGGLE: FeatureFlag
): { isEnabled: boolean; isLoading: boolean } => {
  const { features, isLoading } = useFeatureFlags();

  return { isEnabled: !!features && !!features[TOGGLE]?.enabled, isLoading };
};
